import { ButtonType, ButtonWidget, DialogPositioningBehavior, DialogType, Img } from '@tableau/widgets';
import React from 'react';

import { dialogBodyStyle } from '~src/catalog/styles/ExternalContentActionsStyles';
import { ReactModalService } from '~src/commonInfra/dialogs/ReactModalService';
import { TabDialogWidth } from '~src/commonInfra/dialogs/style/TabDialogWidth';
import { CommonStyles } from '~src/commonInfra/styles/CommonStyles';
import { imgPath } from '~src/commonInfra/utils/ImgUrl';
import { SimulationDescriptionField } from '~src/simulation/components/content/SimulationEditableTextArea';

import { Messages } from '../../codegen/Localize';
import { ISanitizer } from '../../commonInfra/utils/Sanitize';
import { TextileHelper } from '../../spacesPlatform/utils/TextileHelper';
import { cssClass, flexColumnStyle, flexRowStyle } from '../../style';
import { ChangeSimulationDescriptionAction } from '../actions/ChangeSimulationDescriptionAction';
import { ISimulationDetailInfo } from '../models/ISimulationInfo';

export const editSimulationDescriptionButton = 'EDIT-SIMULATION-DESCRIPTION-BUTTON';
const editIcon = imgPath('edit_small_normal.svg');
const cssPrefix = 'SimulationDescription';

const rootClass = cssClass(cssPrefix, 'root', flexColumnStyle);

const headerClass = cssClass(cssPrefix, 'header', flexRowStyle, {
  fontWeight: 'normal',
  fontSize: CommonStyles.Sizes.HeaderFontSize
});

const descriptionContainer = cssClass(cssPrefix, 'description', {
  paddingLeft: 2
});

const noDescription = cssClass(cssPrefix, 'noDescription', {
  paddingTop: CommonStyles.Sizes.DefaultSpace,
  paddingBottom: CommonStyles.Sizes.DefaultSpace
});

const editButton = cssClass(cssPrefix, 'editButton', {
  marginLeft: CommonStyles.Sizes.DefaultSpace,
  minWidth: CommonStyles.Sizes.NormalIconSize,
  height: CommonStyles.Sizes.NormalIconSize,
});

export type SimulationDescriptionProps = {
  readonly editDescriptionAllowed: boolean;
  readonly simulationDetailInfo: ISimulationDetailInfo;
  readonly refreshData: () => void;
  readonly sanitizer: ISanitizer;
};

export class SimulationDescription extends React.PureComponent<SimulationDescriptionProps> {
  private toggleEditing = () => {

    const handleSubmit = (description: string) => {
      ChangeSimulationDescriptionAction.execute(this.props.simulationDetailInfo, description)
        .then(() => {
          this.props.refreshData();
          modal.close();
        });
    };

    const dialogTitle = Messages.editDescription2();

    const modal = ReactModalService.open({
      title: dialogTitle,
      type: DialogType.NormalWithTitleBar,
      showCloseButton: false,
      dismissDialogOnCloseAction: true,
      positioningBehavior: DialogPositioningBehavior.Centered,
      dialogContent: <SimulationDescriptionField
        description={this.props.simulationDetailInfo.description}
        dismissDialog={() => modal.dismiss()}
        doAction={handleSubmit}
        textAreaLabel={dialogTitle}
      />,
      dialogBodyStyle: dialogBodyStyle,
      dialogWidth: TabDialogWidth.width500px
    });

    return Promise.resolve(modal.result)
      .then(() => this.props.refreshData())
      .catch(reason => {
        if (reason === 'cancel' || reason === 'dismissDialog')
          Promise.resolve(reason);
        else
          Promise.reject(reason);
      });
  };

  private EditButton() {
    return (
      <ButtonWidget
        className={editButton}
        buttonType={ButtonType.Icon}
        getContent={this.EditButtonIcon}
        onClick={this.toggleEditing}
        testId={editSimulationDescriptionButton}
        title={Messages.editDescription2()}
      />
    );
  }

  private EditButtonIcon() {
    return (
      <Img
        draggable={false}
        src={editIcon}
      />
    );
  }

  public render() {
    const htmlDescription = TextileHelper.getSanitizedHtmlFromTextile(
      this.props.simulationDetailInfo.description,
      this.props.sanitizer
    );

    /* eslint-disable jsx-a11y/no-static-element-interactions */
    /* eslint-disable jsx-a11y/click-events-have-key-events */
    return (
      <div className={rootClass}>
        <div className={headerClass}>
          <div>{Messages.description()}</div>
          {this.props.editDescriptionAllowed ? this.EditButton() : null}
        </div>
        <div className={descriptionContainer}>
          {this.props.simulationDetailInfo.description ?
            // htmlDescription is already sanitized so suppress the error
            // eslint-disable-next-line jam3/no-sanitizer-with-danger
            <div className={'tb-textile'} dangerouslySetInnerHTML={{ __html: htmlDescription }} />
            : <div className={noDescription}>{Messages.simulationOverviewNoDescription()}</div>}
        </div>
      </div>
    );
  }
}
